"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TankAggregationFns = exports.getAggregateCollectionVolume = exports.getTankWaterAvailabilityData = void 0;
const calculatedStateUtils_1 = require("../../../calculatedStateUtils");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const getTankWaterAvailabilityData = (tankList) => {
    const current_filled_volume = tankList.reduce((acc, curr) => typeof curr.current_filled_volume === 'number'
        ? acc + curr.current_filled_volume
        : typeof curr.current_filled_volume === 'string'
            ? acc + parseInt(curr.current_filled_volume)
            : acc, 0);
    const total_volume = tankList.reduce((acc, curr) => typeof curr._totalVolume === 'number' ? acc + curr._totalVolume : typeof curr._totalVolume === 'string' ? acc + parseInt(curr._totalVolume) : acc, 0);
    const aggregateFillPercentage = Math.round((current_filled_volume / total_volume) * 100);
    const TankWaterAvailabilityData = (0, calculatedStateUtils_1.getTankWaterHealthData)(aggregateFillPercentage);
    return TankWaterAvailabilityData;
};
exports.getTankWaterAvailabilityData = getTankWaterAvailabilityData;
const getAggregateCollectionVolume = (tankList) => {
    const grpAggCollVolumeDebug = false;
    let groupAggregateCollectionVolume = 0;
    if (tankList.length > 0) {
        tankList.forEach((tank) => {
            debug && grpAggCollVolumeDebug && console.log(tank);
            if (tank.forecastCollectionInSevenDays)
                groupAggregateCollectionVolume += tank.forecastCollectionInSevenDays;
        });
    }
    return groupAggregateCollectionVolume;
};
exports.getAggregateCollectionVolume = getAggregateCollectionVolume;
exports.TankAggregationFns = {
    // @ts-ignore
    // hack blame BTO
    current_filled_volume: (tanks) => tanks.reduce((acc, curr, i) => (typeof curr.currentVolume === 'number' ? acc + curr.currentVolume : acc), 0),
    // @ts-ignore
    // hack blame BTO
    total_volume: (tanks) => tanks.reduce((acc, curr, i) => (typeof curr.currentVolume === 'number' ? acc + curr.currentVolume : acc), 0),
    volume_collected_yesterday: (tanks) => tanks.reduce((acc, curr, i) => (typeof curr.volumeCollectedYesterday === 'number' ? acc + curr.volumeCollectedYesterday : acc), 0),
    volume_used_yesterday: (tanks) => tanks.reduce((acc, curr, i) => (typeof curr.volumeUsedYesterday === 'number' ? acc + curr.volumeUsedYesterday : acc), 0),
    tank_water_availability: (tanks) => (0, exports.getTankWaterAvailabilityData)(tanks).water_availability,
    tank_water_availability_message: (tanks) => (0, exports.getTankWaterAvailabilityData)(tanks).water_availability_message,
    updated_at: (tanks) => new Date().toLocaleString('en-NZ'),
    forecastCollectionInSevenDays: (tanks) => (0, exports.getAggregateCollectionVolume)(tanks),
    predicted_run_out_date: (tanks, group) => {
        return (group === null || group === void 0 ? void 0 : group.dailyStateHistory) !== undefined ? group.dailyStateHistory.getLength() : -1;
    },
};
